import { mapActions, mapMutations } from "vuex";

export default {
    data() {
        return {
            catalogList: [],
            catalogSubscribers: {},
            guidCatalogPairs: {},
            localData: {}
        };
    },
    methods: {
        ...mapActions("components", ["getCatalogData"]),
        ...mapMutations("components", ["updateFutureValues", "setCatalogData"]),
        __checkCatalogStuff(guid, properties) {
            if (properties.values) {
                const valuesStr = properties.values.startsWith("c_") ? properties.values.slice(2) : properties.values;
                const splitValues = valuesStr.split(".");
                const [catalog] = splitValues.splice(0, 1);

                if (!this.catalogSubscribers.hasOwnProperty(catalog)) {
                    this.catalogSubscribers[catalog] = [];
                }
                this.catalogList.push(catalog);
                this.catalogSubscribers[catalog].push({ guid, field: splitValues.join(".") });
                this.guidCatalogPairs[guid] = catalog;
            }
        },
        __loadCatalogs() {
            const promises = [];

            this.catalogList.forEach(catalog => {
                const optionsByField = {};
                const catalogPromise = this.getCatalogData(catalog);

                promises.push(catalogPromise);
                catalogPromise.then(data => {
                    this.localData[catalog] = {};
                    data.forEach(entry => {
                        this.localData[catalog][entry.code] = {
                            ...entry.columns,
                            name: entry.name.en || entry.name,
                            code: entry.code
                        };
                    });

                    this.setCatalogData(this.localData);
                    this.catalogSubscribers[catalog].forEach(subscriber => {
                        if (!optionsByField.hasOwnProperty(subscriber.field)) {
                            const options = [];
                            const { field } = subscriber;
                            data.forEach(entry => {
                                const option = { value: entry.code };
                                option._data = { ...this.localData[catalog][entry.code] };

                                if (field === "name") {
                                    option.label = entry.name.en || entry.name;
                                } else if (field === "code") {
                                    option.label = entry.code;
                                } else {
                                    option.label = entry.columns[field];
                                }
                                options.push(option);
                            });
                            optionsByField[subscriber.field] = options;
                        }

                        this.updateFutureValues({ guid: subscriber.guid, data: optionsByField[subscriber.field] });
                    });
                });
            });

            return new Promise(resolve => {
                Promise.all(promises).then(() => resolve());
            });
        }
    }
};
